import { CalendarType } from 'src/app/helpers/enums/settings/review-type/calendarType';

export const CalendarTypeDetails = new Map<number, string>([
  [CalendarType.Events, 'Events'],
    [CalendarType.Tasks, 'Tasks']
  ]);
